// src/components/admin/DriversList.js
import React from 'react';
import RefDictionaryPage from './RefDictionaryPage';

export default function DriversList() {
  return (
    <RefDictionaryPage
      breadcrumbs="Транспорт"
      title="Водители"
      subtitle="Назначаются на путевые листы"
      endpoint="v1/drivers"
      listMapper={(raw) => (Array.isArray(raw) ? raw.filter((d) => !d.is_deleted) : [])}
      searchKeys={['full_name', 'document']}
      extraRefs={{ orgs: 'v1/organizations', divs: 'v1/divisions', vehicles: 'v1/vehicles' }}
      columns={[
        { key: 'id', label: 'ID', width: 70 },
        { key: 'full_name', label: 'ФИО', wrap: true },
        { key: 'document', label: 'Документ', wrap: true },
        {
          key: 'id_organization',
          label: 'Организация',
          width: 180,
          render: (v, _row, refs) => {
            const org = (refs?.orgs || []).find((o) => String(o.id) === String(v));
            return org ? <span className="crmpage__primary">{org.name}</span> : '—';
          },
        },
        {
          key: 'id_division',
          label: 'Подразделение',
          width: 180,
          render: (v, _row, refs) => {
            const d = (refs?.divs || []).find((x) => String(x.id) === String(v));
            return d ? d.name : '—';
          },
        },
        {
          key: 'id_vehicles',
          label: 'Транспорт',
          width: 200,
          render: (v, _row, refs) => {
            const veh = (refs?.vehicles || []).find((x) => String(x.id) === String(v));
            return veh ? (
              <span>
                <span className="crmpage__primary">{veh.name || `#${veh.id}`}</span>
                {veh.registration_number && (
                  <span className="crmpage__sub">{veh.registration_number}</span>
                )}
              </span>
            ) : '—';
          },
        },
      ]}
      fields={[
        { key: 'full_name', label: 'ФИО', required: true, placeholder: 'Иванов Иван Иванович' },
        { key: 'document', label: 'Документ', placeholder: 'удостоверение №…' },
        { key: 'id_organization', label: 'Организация', type: 'select', refsKey: 'orgs', required: true },
        { key: 'id_division', label: 'Подразделение', type: 'select', refsKey: 'divs' },
        { key: 'id_vehicles', label: 'Транспорт', type: 'select', refsKey: 'vehicles' },
      ]}
      emptyRecord={{ full_name: '', document: '', id_organization: '', id_division: '', id_vehicles: '' }}
      itemTitle={(d) => d?.full_name}
    />
  );
}
